import React from 'react'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import UndoIcon from '@material-ui/icons/Undo'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import strings from 'strings'
import { formatRelative } from 'components/CollaborativeTasks/ctHelpers'

const NotificationRow = ({ notification, onClick }) => {
    if (!notification) return null

    // General (non-task) notifications — e.g. monitoring alerts — carry their own title/message + deep-link
    // rather than the actor/verb/task shape. Render them generically.
    if (notification.category && notification.category !== 'TASK') {
        return (
            <button className="nbell-row" onClick={() => onClick(notification)}>
                <span className={`nbell-row__unread ${notification.read ? 'is-read' : ''}`} />
                <span className="nbell-row__icon nbell-row__icon--monitoring">
                    <NotificationsNoneIcon style={{ fontSize: 14 }} />
                </span>
                <span className="nbell-row__body">
                    <span className="nbell-row__sentence">
                        <strong>{notification.title}</strong>{notification.message ? ` ${notification.message}` : ''}
                    </span>
                    <span className="nbell-row__time">{formatRelative(notification.occurredAt)}</span>
                </span>
            </button>
        )
    }

    const t = strings.CT_BELL
    const actor = notification.actor?.name || notification.actor?.email || 'Someone'
    const verb = ({
        ASSIGNED: t.EVENT_ASSIGNED,
        REJECTED: t.EVENT_REJECTED,
        COMPLETED: t.EVENT_COMPLETED
    })[notification.eventType] || ''
    const taskTitle = notification.task?.title || ''
    const iconKind = (notification.eventType || '').toLowerCase()

    return (
        <button className="nbell-row" onClick={() => onClick(notification)}>
            <span className={`nbell-row__unread ${notification.read ? 'is-read' : ''}`} />
            <span className={`nbell-row__icon nbell-row__icon--${iconKind}`}>
                {iconKind === 'completed' && <CheckCircleOutlineIcon style={{ fontSize: 14 }} />}
                {iconKind === 'rejected' && <UndoIcon style={{ fontSize: 14 }} />}
                {iconKind === 'assigned' && <ArrowForwardIcon style={{ fontSize: 14 }} />}
            </span>
            <span className="nbell-row__body">
                <span className="nbell-row__sentence">
                    <strong>{actor}</strong> {verb} <strong>{taskTitle}</strong>
                </span>
                {notification.reason && (
                    <span className="nbell-row__reason">"{notification.reason}"</span>
                )}
                <span className="nbell-row__time">{formatRelative(notification.occurredAt)}</span>
            </span>
        </button>
    )
}

export default NotificationRow
